import LocationChatBot from "./src/App";

declare global {
    export type locationChatBot = LocationChatBot;
    export const locationChatBot: typeof LocationChatBot;

    interface Window {
        LocationChatBot: LocationChatBot;
    }
}

(window as any).LocationChatBot = LocationChatBot;